import { executeRequest, JFSRequest } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  console.log('response=', response)
  if (response.data?.recordStatus === 'SUCCESS') {
    return response?.data
  }
  throw response?.data
}

const updateRoutingStatus = (status: boolean, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.updateRoutingStatus),
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      status: status ? 'ACTIVE' : 'INACTIVE',
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { updateRoutingStatus }
